import { VoxelScreen } from "./Voxels/VoxelScreen";
export function GameScreens() {
    VoxelScreen();
}
